import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
const courses = [{
  title: 'Curso Completo de Barbería',
  desc: 'Desde cero hasta nivel profesional. Dominá todas las técnicas fundamentales.'
}, {
  title: 'Técnicas de Fade Profesional',
  desc: 'Perfeccioná tus degradados. Masterclass intensiva para barberos con experiencia.'
}, {
  title: 'Diseño y Afeitado de Barba',
  desc: 'El arte del ritual clásico. Toalla caliente, navaja y perfilado perfecto.'
}];
export function Courses() {
  return <section id="cursos" className="py-24 bg-dark-surface relative overflow-hidden" data-id="element-46">
      {/* Decorative gradient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-47"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-50">
            Cursos Profesionales de <span className="text-gold" data-id="element-51">Barbería</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300 font-serif italic" data-id="element-52">
            Convertite en un barbero de élite
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-53">
          {courses.map((course, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark p-8 rounded-sm border border-gold/20 relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-54">
              <div className="absolute -top-3 right-6 bg-gold text-dark text-xs font-bold px-3 py-1 rounded-sm tracking-wider" data-id="element-55">
                CUPOS LIMITADOS
              </div>
              <h3 className="text-2xl font-bold mb-4 mt-4" data-id="element-56">{course.title}</h3>
              <p className="text-gray-400 mb-8" data-id="element-57">{course.desc}</p>
              <button className="flex items-center gap-2 text-gold font-semibold group-hover:text-gold-light transition-colors" data-id="element-58">
                QUIERO INSCRIBIRME{' '}
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-59" />
              </button>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 bg-dark-card p-6 md:p-10 rounded-sm border border-white/5 mb-16" data-id="element-60">
          <div className="w-full md:w-1/3 aspect-[9/16] max-h-[400px] rounded-sm overflow-hidden border border-gold/20 shrink-0 mx-auto" data-id="element-61">
            <video src="https://cdn.magicpatterns.com/uploads/mc1eWWy86W3pkBcq5ZEtKt/instasaved-08-06-2026 (4).mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-62" />
          </div>
          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-63">
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-64">
              Formando a la nueva generación
            </h3>
            <p className="text-gray-400 mb-6 text-lg" data-id="element-65">
              Nuestros alumnos se gradúan con las herramientas, técnicas y la
              confianza necesaria para destacar en el mundo de la barbería
              profesional. Sumate a nuestra academia y empezá tu carrera hoy
              mismo.
            </p>
            <div className="inline-flex items-center gap-2 text-gold font-semibold px-6 py-3 border border-gold/50 rounded-sm hover:bg-gold/10 transition-colors" data-id="element-66">
              <Star size={18} className="fill-gold" data-id="element-67" />
              Certificación Profesional
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-3 text-gray-400 bg-dark/50 py-4 px-6 rounded-sm w-fit mx-auto border border-white/5" data-id="element-68">
          <Star className="text-gold fill-gold" size={20} data-id="element-69" />
          <p className="font-medium" data-id="element-70">
            Más de 100 alumnos formados — Aprendé con los mejores
          </p>
        </motion.div>
      </div>
    </section>;
}